import PropTypes from 'prop-types';

const PVPropsProductDetailType = PropTypes.shape({
    ID: PropTypes.number,
    ItemID: PropTypes.string,
    Name: PropTypes.string,
    ShortDesc: PropTypes.string,
    Price: PropTypes.number,
    FreightType: PropTypes.number,
    ThumbnailImagePath: PropTypes.string,
    ImagePath: PropTypes.string,
    AlternateItem: PropTypes.string,
    CategoryIds: PropTypes.arrayOf(PropTypes.number),
    Rank: PropTypes.number,
    ItemGroupID: PropTypes.string,
    IsBOM: PropTypes.bool,
    ItemMeetsDisplayRequirements: PropTypes.bool,
    ItemMeetsPurchaseRequirements: PropTypes.bool,
    UsersAccountIsBlockedOrStopped: PropTypes.bool,
    InternalOnly: PropTypes.bool,
    SwitchAccountsToPurchase: PropTypes.bool,
    OutOfStockPhoneNumber: PropTypes.string,
    Logos: PropTypes.shape({
        DTV: PropTypes.bool,
        Exede: PropTypes.bool,
        PatentPending: PropTypes.bool,
        FreeShipping: PropTypes.bool,
    }),
    BreadCrumbs: PropTypes.arrayOf(
        PropTypes.shape({
            sortOrder: PropTypes.number,
            linkTarget: PropTypes.string,
            linkText: PropTypes.string,
        })
    ),
    TextBody: PropTypes.string,
    PricingDetails: PropTypes.arrayOf(
        PropTypes.shape({
            QtyMin: PropTypes.number,
            QtyMax: PropTypes.number,
            Price: PropTypes.number,
            AccountNum: PropTypes.string,
        })
    ),
    Dimensions: PropTypes.arrayOf(
        PropTypes.shape({
            Height: PropTypes.number,
            Width: PropTypes.number,
            Depth: PropTypes.number,
            Weight: PropTypes.number,
            UnitID: PropTypes.string,
            Quantity: PropTypes.number,
        })
    ),
    ProductTexts: PropTypes.arrayOf(
        PropTypes.shape({
            ID: PropTypes.number,
            TextBody: PropTypes.string,
            WebDisplay: PropTypes.bool,
            SortOrder: PropTypes.number,
            TypeName: PropTypes.string,
        })
    ),
    BOMProduct: PropTypes.arrayOf(
        PropTypes.shape({
            Name: PropTypes.string,
            ProductID: PropTypes.number,
        })
    ),
});

export default PVPropsProductDetailType;
